import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { HeadingTags } from '@primer/react-brand';
import { Box as Container } from '@primer/react';
import { PropTableValues } from '../../../src/components';
import { Label } from '@primer/react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {FAQ, FAQGroup} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <FAQ>
    <FAQ.Heading>Frequently asked questions</FAQ.Heading>
    <FAQ.Item>
      <FAQ.Question>
        What&apos;s included in the GitHub for Startups offer?
      </FAQ.Question>
      <FAQ.Answer>
        <p>
          All GitHub for Startups companies receive up to 20 seats of GitHub
          Enterprise for free for year one and 50% off year two. Learn more
          about the features and capabilities of GitHub Enterprise{' '}
          <InlineLink
            href="https://www.github.com"
            target="_blank"
            rel="noreferrer"
          >
            here
          </InlineLink>
          .
        </p>
      </FAQ.Answer>
    </FAQ.Item>
    <FAQ.Item>
      <FAQ.Question>Who is eligible to apply?</FAQ.Question>
      <FAQ.Answer>
        <p>
          Startups who meet the following criteria are eligible to apply for the
          program:
        </p>
        <ol>
          <li>
            <Text size="300" variant="muted">
              Must be associated with a current GitHub for Startups partner.
            </Text>
          </li>
          <li>
            <Text size="300" variant="muted">
              Self-funded or funded (Seed-Series A)
            </Text>
          </li>
          <li>
            <Text size="300" variant="muted">
              Not a current GitHub Enterprise customer
            </Text>
          </li>
          <li>
            <Text size="300" variant="muted">
              Must not have previously received credits for GitHub Enterprise
            </Text>
          </li>
        </ol>
      </FAQ.Answer>
    </FAQ.Item>
    <FAQ.Item>
      <FAQ.Question>
        What if my startup is not eligible? Are there other resources for me?
      </FAQ.Question>
      <FAQ.Answer>
        <p>
          If you’re not currently eligible for the GitHub for Startups but would
          like to try GitHub Enterprise, please feel to sign up for a trial
          <InlineLink
            href="https://www.github.com"
            target="_blank"
            rel="noreferrer"
          >
            here
          </InlineLink>.
        </p>
      </FAQ.Answer>
    </FAQ.Item>
    <FAQ.Item>
      <FAQ.Question>
        How can my organization become a GitHub for Startups partner?
      </FAQ.Question>
      <FAQ.Answer>
        <p>
          Any investor, accelerator, or startup support organization is eligible
          to apply for the GitHub for Startups program.
        </p>
        <p>
          <InlineLink
            href="https://www.github.com"
            target="_blank"
            rel="noreferrer"
          >
            Apply here
          </InlineLink>
          .
        </p>
      </FAQ.Answer>
    </FAQ.Item>
  </FAQ>
</>
`}</code></pre>
    <h3>{`Grouped FAQs`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`FAQGroup`}</inlineCode>{` to display multiple `}<inlineCode parentName="p">{`FAQ`}</inlineCode>{` components together.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FAQGroup>
  <FAQGroup.Heading>
    Frequently asked <br /> questions
  </FAQGroup.Heading>
  <FAQ>
    <FAQ.Heading>Using GitHub Enterprise</FAQ.Heading>
    <FAQ.Item>
      <FAQ.Question>What is GitHub Enterprise?</FAQ.Question>
      <FAQ.Answer>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
          ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
          elementum.
        </p>
      </FAQ.Answer>
    </FAQ.Item>
    <FAQ.Item>
      <FAQ.Question>How can GitHub Enterprise be deployed?</FAQ.Question>
      <FAQ.Answer>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
          ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
          elementum.
        </p>
      </FAQ.Answer>
    </FAQ.Item>
    <FAQ.Item>
      <FAQ.Question>What is GitHub Enterprise Cloud?</FAQ.Question>
      <FAQ.Answer>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
          ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
          elementum.
        </p>
      </FAQ.Answer>
    </FAQ.Item>
  </FAQ>

  <FAQ>
    <FAQ.Heading>About GitHub Enterprise</FAQ.Heading>
    <FAQ.Item>
      <FAQ.Question>
        What is the difference between GitHub and GitHub Enterprise?
      </FAQ.Question>
      <FAQ.Answer>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
          ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
          elementum.
        </p>
      </FAQ.Answer>
    </FAQ.Item>
    <FAQ.Item>
      <FAQ.Question>
        Why should organizations use GitHub Enterprise?
      </FAQ.Question>
      <FAQ.Answer>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
          ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
          elementum.
        </p>
      </FAQ.Answer>
    </FAQ.Item>
    <FAQ.Item>
      <FAQ.Question>Who uses GitHub Enterprise?</FAQ.Question>
      <FAQ.Answer>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
          ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
          elementum.
        </p>
      </FAQ.Answer>
    </FAQ.Item>
  </FAQ>
</FAQGroup>
`}</code></pre>
    <h3>{`Rendering with dynamic data`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const App = () => {
  const fixtureData = [
    {
      question: 'How do I render a single paragraph?',
      answer: (
        <p>
          Vestibulum at dolor justo.{' '}
          <InlineLink
            href="https://www.github.com"
            target="_blank"
            rel="noreferrer"
          >
            Curabitur
          </InlineLink>{' '}
          dictum feugiat elit, vitae vestibulum orci vestibulum sed. Donec
          interdum ligula at nisi rhoncus malesuada et non eros.
        </p>
      ),
    },
    {
      question: 'What about multiple paragraphs?',
      answer: (
        <React.Fragment>
          <p>
            Vestibulum at dolor justo.{' '}
            <InlineLink
              href="https://www.github.com"
              target="_blank"
              rel="noreferrer"
            >
              Curabitur
            </InlineLink>{' '}
            dictum feugiat elit, vitae vestibulum orci vestibulum sed. Donec
            interdum ligula at nisi rhoncus malesuada et non eros.
          </p>
          <p>
            Pellentesque habitant morbi tristique senectus et netus et malesuada
            fames ac turpis egestas.
          </p>
        </React.Fragment>
      ),
    },
    {
      question: 'Can I render a React Fragment?',
      answer: (
        <React.Fragment>
          <p>
            Vestibulum at dolor justo.{' '}
            <InlineLink
              href="https://www.github.com"
              target="_blank"
              rel="noreferrer"
            >
              Curabitur
            </InlineLink>{' '}
            dictum feugiat elit, vitae vestibulum orci vestibulum sed. Donec
            interdum ligula at nisi rhoncus malesuada et non eros.
          </p>
          <ol>
            <li>
              <Text size="300" variant="muted">
                Must be associated with a current GitHub for Startups partner.
              </Text>
            </li>
            <li>
              <Text size="300" variant="muted">
                Self-funded or funded (Seed-Series A)
              </Text>
            </li>
            <li>
              <Text size="300" variant="muted">
                Not a current GitHub Enterprise customer
              </Text>
            </li>
            <li>
              <Text size="300" variant="muted">
                Must not have previously received credits for GitHub Enterprise
              </Text>
            </li>
          </ol>
        </React.Fragment>
      ),
    },
  ]

  return (
    <FAQ>
      <FAQ.Heading>Frequently asked questions</FAQ.Heading>
      <>
        {fixtureData.map(({question, answer}) => {
          return (
            <FAQ.Item key={question} open={false}>
              <FAQ.Question>{question}</FAQ.Question>
              <FAQ.Answer>{answer}</FAQ.Answer>
            </FAQ.Item>
          )
        })}
      </>
    </FAQ>
  )
}

render(<App />)
`}</code></pre>
    <h3>{`Color customization`}</h3>
    <p><inlineCode parentName="p">{`FAQ`}</inlineCode>{` surfaces component-specific css variables that can be used to adjust the color where needed.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const App = () => {
  const designTokenOverrides = \`
  .custom-colors[data-color-mode='dark'] {

    /*
     * Modify the value of these tokens.
     * Remember to apply light mode equivalents if you're enabling theme switching.
     */
    --brand-Accordion-toggle-color-start: var(--base-color-scale-green-1);
    --brand-Accordion-toggle-color-end: var(--base-color-scale-blue-3);
    --brand-FAQ-color-heading: linear-gradient(271.72deg, var(--base-color-scale-green-1) 7.09%, var(--base-color-scale-blue-3) 96.61%);

    padding: 3rem;
    background-color: var(--brand-color-canvas-default);
  }


  .custom-heading {
    background: var(--brand-FAQ-color-heading);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
\`

  return (
    <ThemeProvider colorMode="dark" className="custom-colors">
      <style>{designTokenOverrides}</style>
      <FAQ>
        <FAQ.Heading className="custom-heading">
          Frequently asked questions
        </FAQ.Heading>
        <FAQ.Subheading>Subscriptions & Payments</FAQ.Subheading>
        <FAQ.Item>
          <FAQ.Question>
            What are the differences between GitHub Free, GitHub Pro, GitHub
            Team and GitHub Enterprise plans?
          </FAQ.Question>
          <FAQ.Answer>
            <p>
              GitHub Free is our basic plan created for individuals and small
              teams to collaborate on private and public repositories.
            </p>
          </FAQ.Answer>
        </FAQ.Item>
        <FAQ.Item>
          <FAQ.Question>How do I view and manage my subscription?</FAQ.Question>
          <FAQ.Answer>
            <p>
              You can view your account's subscription, your other paid features
              and products, and your next billing date in your account's billing
              settings.
            </p>
          </FAQ.Answer>
        </FAQ.Item>
        <FAQ.Item>
          <FAQ.Question>How can I change my GitHub subscription?</FAQ.Question>
          <FAQ.Answer>
            <p>
              You can upgrade or downgrade your subscription, add and remove
              seats, or change the billing cadence on
              https://github.com/settings/billing.
            </p>
          </FAQ.Answer>
        </FAQ.Item>
      </FAQ>
    </ThemeProvider>
  )
}

render(<App />)
`}</code></pre>
    <h2>{`Component props`}</h2>
    <h3>{`FAQ `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom id`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.RefObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Forward a Ref to the underlying DOM node`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[<a href="#faq-heading">FAQ.Heading</a>, <a href="#faq-subheading">FAQ.Subheading</a>, <a href="#faq-item">FAQ.Item</a>]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Root element for the FAQ component.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 id="faq-heading">
  FAQ.Heading <Label mdxType="Label">Required</Label>
    </h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`align`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['start', 'center']} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'center'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Heading text alignment`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Heading text`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Heading custom class`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom id`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.RefObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Forward a Ref to the underlying DOM node`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`size`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['medium', 'large']} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'medium'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Heading text size`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={HeadingTags} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies the underlying HTML element`}</td>
        </tr>
      </tbody>
    </table>
    <h3 id="faq-subheading">FAQ.Subheading</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sub-heading text`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sub-heading custom class`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom id`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={HeadingTags.slice(1)} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'h3'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies the underlying HTML element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.RefObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Forward a Ref to the underlying DOM node`}</td>
        </tr>
      </tbody>
    </table>
    <h3 id="faq-item">FAQ.Item</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`open`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets answer visibility`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[<a href="#faq-question">FAQ.Question</a>, <a href="#faq-answer">FAQ.Answer</a>]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`FAQ question and answer pair`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom id`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.RefObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Forward a Ref to the underlying DOM node`}</td>
        </tr>
      </tbody>
    </table>
    <h3 id="faq-question">FAQ.Question</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Question text`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom id`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={HeadingTags.slice(1)} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'h4'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies the underlying HTML element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.RefObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Forward a Ref to the underlying DOM node`}</td>
        </tr>
      </tbody>
    </table>
    <h3 id="faq-answer">FAQ.Answer</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactElement`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`<p>`}</inlineCode>{` or `}<inlineCode parentName="td">{`<Text>`}</inlineCode>{` components are recommended`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom id`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.RefObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Forward a Ref to the underlying DOM node`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`FAQGroup`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom id`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.RefObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Forward a Ref to the underlying DOM node`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[<a href="#faq-required">FAQ</a>, <a href="#faqgroup-heading">FAQGroup.Heading</a>]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Root element for the FAQGroup component.`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`FAQGroup.Heading`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={HeadingTags} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies the underlying HTML element`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Forwards all the props from the `}<a parentName="p" {...{
        "href": "/components/Heading"
      }}>{`Heading component`}</a>{`, including `}<inlineCode parentName="p">{`size`}</inlineCode>{`, and `}<inlineCode parentName="p">{`weight`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      